import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourRecetSecciones: TourDefinicion = {
  codigo: 'recet-secciones',
  titulo: 'Secciones',
  descripcion:
    'Templates de secciones que componen las tecnologías: orden, habilitación y creación.',
  ruta: '/admin/recet/secciones',
  permisoMenu: Permisos.SECCIONES_MENU,
  pasos: [
    {
      id: 'recet-secciones:header',
      selector: '[data-testid="recet-secciones.header"]',
      titulo: 'Templates de Secciones',
      descripcion:
        'Define las secciones que compondrán cada tecnología nueva. El orden que establezcas aquí se refleja en todas las tecnologías.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'recet-secciones:boton-crear',
      selector: '[data-testid="recet-secciones.boton-crear"]',
      titulo: 'Nueva sección',
      descripcion: 'Agrega una sección nueva al template. Queda activa de inmediato.',
      permisoRequerido: Permisos.SECCIONES_CREAR,
      side: 'left',
      align: 'center',
    },
    {
      id: 'recet-secciones:tabla',
      selector: '[data-testid="recet-secciones.tabla"]',
      titulo: 'Listado y orden',
      descripcion:
        'Reordena con arrastrar y soltar. Desde cada fila puedes editar el nombre o deshabilitar sin perder los datos históricos.',
      side: 'top',
      align: 'center',
    },
  ],
};
